/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ workspace: NonNullable<unknown> }} Invite_TitleInputs */

const en_invite_title = /** @type {(inputs: Invite_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Join ${i?.workspace}`)
};

/** @type {(inputs: Invite_TitleInputs) => LocalizedString} */
const ar_invite_title = en_invite_title;

/** @type {(inputs: Invite_TitleInputs) => LocalizedString} */
const he_invite_title = en_invite_title;

/** @type {(inputs: Invite_TitleInputs) => LocalizedString} */
const ur_invite_title = en_invite_title;

/** @type {(inputs: Invite_TitleInputs) => LocalizedString} */
const es_invite_title = en_invite_title;

/** @type {(inputs: Invite_TitleInputs) => LocalizedString} */
const fr_invite_title = en_invite_title;

/** @type {(inputs: Invite_TitleInputs) => LocalizedString} */
const de_invite_title = en_invite_title;

/** @type {(inputs: Invite_TitleInputs) => LocalizedString} */
const pt_invite_title = en_invite_title;

/** @type {(inputs: Invite_TitleInputs) => LocalizedString} */
const hi_invite_title = en_invite_title;

/** @type {(inputs: Invite_TitleInputs) => LocalizedString} */
const bn_invite_title = en_invite_title;

/**
* | output |
* | --- |
* | "Join {workspace}" |
*
* @param {Invite_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_title = /** @type {((inputs: Invite_TitleInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_TitleInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_title(inputs)
	if (locale === "he") return he_invite_title(inputs)
	if (locale === "ur") return ur_invite_title(inputs)
	if (locale === "es") return es_invite_title(inputs)
	if (locale === "fr") return fr_invite_title(inputs)
	if (locale === "de") return de_invite_title(inputs)
	if (locale === "pt") return pt_invite_title(inputs)
	if (locale === "hi") return hi_invite_title(inputs)
	if (locale === "bn") return bn_invite_title(inputs)
	return en_invite_title(inputs)
});